<template>
  <div>
    <form-wizard
      :title="title"
      :subtitle="subtitle"
      :nextButtonText="nextButtonText"
      :backButtonText="backButtonText"
      :finishButtonText="finishButtonText"
      @on-complete="submit"
      color="#4fd1c5"
      class="font-normal content-center border-t items-center">
      <tab-content
        title="Addresse"
        icon="ti-map-alt"
        class="pt-6"
        :before-change="()=> validateStep('step1')"
      >
        <Step1 ref="step1" @on-validate="mergePartialModels" :cartItems="cartItems" :finalModel="finalModel"></Step1>
      </tab-content>
      <tab-content
        title="Versandmethode auswählen"
        icon="ti-truck"
        :before-change="()=> validateStep('step2')"
      >
        <Step2 ref="step2" @on-validate="mergePartialModels" :cartItems="cartItems" :finalModel="finalModel"></Step2>
      </tab-content>
      <tab-content
        title="Zahlungsart"
        icon="ti-shopping-cart"
        :before-change="()=> validateStep('step3')"
      >
        <Step3
          :cartItems="cartItems"
          :finalModel="finalModel"
          ref="step3"
          @on-validate="mergePartialModels"
        ></Step3>
      </tab-content>
      <tab-content title="Bestätigen" icon="ti-shopping-cart-full">
        <div>
          <OrderReview :cartItems="cartItems" :finalModel="finalModel" />
        </div>
      </tab-content>
      <div class="float-right border-t"></div>
    </form-wizard>
  </div>
</template>

<script>
import axios from "axios";
import OrderReview from "./OrderReview";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
// import OrderItems from "./OrderItems";

import { required } from "vuelidate/lib/validators";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    nextButtonText: {
      type: String,
      default: "Weiter",
    },
    backButtonText: {
      type: String,
      default: "Zurück",
    },
    finishButtonText: {
      type: String,
      default: "Fertig",
    },
    icon: {
      type: String,
      default: "1",
    },
  },
  components: {
    OrderReview,
    Step1,
    Step2,
    Step3,
    // OrderItems
  },
  data() {
    return {
      step: 1,
      cartItems: [],
      vendor_id: "",
      warehouse_id: "",
      shop_id: "",
      shipping_address: [],

      billing_address: [],
      amount: 1,
      radio: "1",
      payment: "Stripe",
      checked: false,
      isDefault: false,
      isEmpty: true,
      shipping: "Free Shipping",
      finalModel: {},
      user: {}
    };
  },
  validations: {
    address_1: {
      required,
    },
    address_2: {
      required,
    },

    form: ["address_1", "address_2"],
  },
  mounted() {
    this.cartItems = JSON.parse(localStorage.getItem("cart"));
  },
  computed: {
    total() {
      let sum = 0;
      this.cartItems.map((item) => {
        sum += item.sale_price;
      });
      return sum;
    },
  },
  created() {
    // this.getAddress();
    this.getUser();
  },
  methods: {
    getUser() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios.get(`${process.env.VUE_APP_API}/user`).then(response => {
        // console.log(response);
        this.user = response.data.data;
      })
    },
    onComplete: function () {
      alert("Yay. Done!");
    },
    prev() {
      this.step--;
    },
    next() {
      this.step++;
    },
    submit() {
    },

    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model, this.user);

         let shipAddress = {
          address_1: this.finalModel.address_1,
          address_2: this.finalModel.address_2,
          delivery_date: this.finalModel.delivery_date,
          city: this.finalModel.city,
          state: this.finalModel.state,
          zip: this.finalModel.zip,
          country: this.finalModel.country,
        };

        let billAddress = {
          address_1: this.finalModel.billing_address_1,
          address_2: this.finalModel.billing_address_2,
          city: this.finalModel.billing_city,
          state: this.finalModel.billing_state,
          zip: this.finalModel.billing_zip,
          country: this.finalModel.billing_country,
        };

        let items = this.cartItems.map((item) => {
          if(item.is_light == true) {
            return [item.light_id, this.is_light = true];
          }
          else {
            return [item.shopmarketplace_id, this.is_light = false];
          }
        })

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + localStorage.getItem("access_token");

        axios.post(`${process.env.VUE_APP_API}/order-click`, {
          step: `STEP_${this.finalModel.step}`,
          shipping_address: JSON.stringify(shipAddress),
          billing_address: JSON.stringify(billAddress),
          items: items
        }).catch(error => {
          console.log(error)
        });

        // console.log(items)

        // console.log(this.finalModel);
      }
    },
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/css/themify-icons.css");
</style>